const qs = require('qs')
const { showError, showNotifikasi } = require('../../libs/helper')

module.exports = {
  getRuangan: (g, data) => {
    /* Call Api
    sensus-pengguna-b/setup/ruang/list
    */
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/ruang/list`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  putRuangan: (g, data) => {
    /* Call Api
    sensus-pengguna-b/setup/ruang/create
    */
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/ruang/update`,
      method: 'post',
      data: qs.stringify({
        ...data,
        username: g.$cookies.get('username'),
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(() => {
      showNotifikasi(g, 'success', 'Edit Ruangan', 'Ruangan berhasil diedit')
      return { isSuccess: true }
    }).catch(err => {
      showError(g, err, 'Error Get Data')
      return { isSuccess: false }
    })
    return result
  },
  postRuangan: (g, data) => {
    /* Call Api
    sensus-pengguna-b/setup/ruang/create
    */
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/ruang/create`,
      method: 'post',
      data: qs.stringify({
        ...data,
        username: g.$cookies.get('username'),
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => {
      if (res.data.code == 400) {
        showError(g, { message: res.data.message }, 'Error Get Data')
        return { isSuccess: false }
      }
      showNotifikasi(g, 'success', 'Tambah Ruangan', 'Ruangan berhasil ditambahkan')
      return { isSuccess: true }
    }).catch(err => {
      showError(g, err, 'Error Get Data')
      return { isSuccess: false }
    })
    return result
  },
  deleteRuangan: (g, data) => {
    /* Call Api
    sensus-pengguna-b/setup/ruang/delete
    */
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/ruang/delete`,
      method: 'post',
      data: qs.stringify({
        ...data,
        username: g.$cookies.get('username'),
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(() => {
      showNotifikasi(g, 'success', 'Hapus Ruangan', 'Ruangan berhasil dihapus')
      return { isSuccess: true }
    }).catch(err => {
      showError(g, err, 'Error Get Data')
      return { isSuccess: false }
    })
    return result
  },
  submitRuangan: (g, data) => {
    /* Call Api
    sensus-pengguna-b/setup/list-ruangan
    */
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/ruang/submit`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(() => {
      g.$router.push({ name: 'bRuangan' })
    }).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  getDetail: (g, data) => {
    /* Call Api
    sensus-pengguna-b/setup/ruang/detail
    */
   console.log("post", data)
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/ruang/detail`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  printQrCode: async (g, data) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/setup/ruang/print`,
      method: 'post',
      data: qs.stringify({
        ...data,
        username: g.$cookies.get('username'),
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/octet-stream',
      },
      responseType: 'blob',
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
}
